import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import TabsClientNew from "../Components/new-client-dashboard/NewTabs";
import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import DocumentRow from "../Components/DocumentRow/DocumentRow";
import RelationTabs from "../Components/wrongful-death-page/tabs/relations";
import OutsideRepresentaion from "../Components/wrongful-death-page/tabs/outside-representation";
import AdverseDefendants from "../Components/wrongful-death-page/tabs/adverse-defendants";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

const PAGE_TITLES = {
  relation: "Relations",
  outsideRepresentation: "Outside Representation",
  adverseDefendants: "Adverse Defendants",
  photo: "Photos",
};

const PHOTO_ICON_URL =
  "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const PageTitle = ({ currentPage }) => (
  <div
    style={{
      width: "100%",
      justifyContent: "flex-start",
      background: "var(--primary)",
      height: "25px",
      marginBottom: "5px",
    }}
  >
    <span
      className="fw-bold text-white"
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {PAGE_TITLES[currentPage]}
    </span>
  </div>
);

const PageContent = ({ currentPage }) => {
  switch (currentPage) {
    case "relation":
      return <RelationTabs />;
    case "outsideRepresentation":
      return <OutsideRepresentaion />;
    case "adverseDefendants":
      return <AdverseDefendants />;
    case "photo":
      return <PhotoTab pageId={72} pageName={""} />;
    default:
      return null;
  }
};

const WrongfulDeathPage = () => {
  const [currentPage, setCurrentPage] = useState("relation");
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 72).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 72, dispatch);
  }, [dispatch]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(
    () => [
      {
        id: "relation",
        label: "Relations",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("relation"),
        leftHand: false,
      },
      {
        id: "outsideRepresentation",
        label: "Outside Representation",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("outsideRepresentation"),
        leftHand: false,
      },
      {
        id: "adverseDefendants",
        label: "Adverse Defendants",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("adverseDefendants"),
        leftHand: false,
      },
    ],
    [handlePageChange]
  );

  const actionTabs = useMemo(
    () => [
      {
        id: "new-relative",
        label: "New Relative",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {},
        leftHand: true,
        span: <span className="fw-bold p-r-5 text-gold">+</span>,
      },
    ],
    []
  );

  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span className="fw-bold text-gold p-r-5">
            <img
              src={PHOTO_ICON_URL}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Summary"
              className="d-flex align-items-center justify-content-center"
            />
          </span>
        ),
      },
    ],
    []
  );

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="72" />
          <ActionBarComponent
            src=""
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <div className="d-flex align-items-center">
              <div style={{ width: "50%" }}>
                <NewChangesTabs
                  currentTab={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start"
                />
              </div>
              <div style={{ width: "35%" }}>
                <MoreChangesTab
                  currentTab={currentPage}
                  tabsData={actionTabs}
                  height={25}
                  popupTabs={true}
                  labelClass="ps-2 justify-content-start"
                />
              </div>
              <div style={{ width: "15%", position: "relative", right: "208px" }}>
                <MoreChangesTab
                  currentTab={currentPage}
                  tabsData={photoTabs}
                  height={25}
                  labelClass="p-l-5 p-r-5 justify-content-end"
                />
              </div>
            </div>

            <PageTitle currentPage={currentPage} />
            <PageContent currentPage={currentPage} />
            <div className=" documents-wrapper m-t-5" style={{ marginRight: "0px" }}>
              <div className="col-12 pe-0">
                <DocumentRow pageName="Wrong Death" clientProvider={""} page_id={72} />
              </div>
            </div>

            <NotesSectionDashboard pageName={"WrongfulDeath"} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default WrongfulDeathPage;
